import { CheckCircle2 } from 'lucide-react';
import { CountdownRedirect } from './CountdownRedirect';

interface SuccessScreenProps {
  title: string;
  message: string;
  countdownSeconds: number;
  redirectPath: string;
  userName?: string;
}

export function SuccessScreen({
  title,
  message,
  countdownSeconds,
  redirectPath,
  userName,
}: SuccessScreenProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50 flex flex-col justify-center py-12 px-4">
      <div className="max-w-md w-full mx-auto">
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6 animate-bounce">
            <CheckCircle2 className="w-12 h-12 text-green-600" />
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-3">
            {userName ? `${title}, ${userName}!` : title}
          </h2>
          <p className="text-lg text-gray-600 mb-6">{message}</p>
          <CountdownRedirect
            seconds={countdownSeconds}
            redirectPath={redirectPath}
            skipButtonText="Go to Dashboard Now"
          />
        </div>
      </div>
    </div>
  );
}
